module.exports = __webpack_public_path__ + "04_short_brown.9011f094.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_short_brown.png
// module id = uB7W
// module chunks = 0